import type { DescriptiveDateRange } from "@entrilia/shared/utilities/dateFilterHelper";
import {
  anytime,
  lastMonth,
  lastQuarter,
  lastYear,
  next30Days,
  nextQuarter,
  nextSevenDays,
  thisMonth,
  thisQuarter,
  thisYear,
  today,
} from "@entrilia/shared/utilities/dateFilterHelper";
import type { CashFlowLine, CashFlowPortalStatus } from "../../../../../api/types/fundStructureTypes";

export interface InvestorCashFlowsFilterState {
  searchTerm: string;
  selectedPortalStatuses: CashFlowPortalStatus[];
  selectedFundIds: string[];
  selectedDateRange: DescriptiveDateRange | undefined;
}

export const getInitialInvestorCashFlowsFilterState = (): InvestorCashFlowsFilterState => ({
  searchTerm: "",
  selectedPortalStatuses: [],
  selectedFundIds: [],
  selectedDateRange: undefined,
});

export const cashFlowsFilterDateRanges: DescriptiveDateRange[] = [
  anytime,
  today,
  nextSevenDays,
  next30Days,
  nextQuarter,
  thisMonth,
  thisQuarter,
  thisYear,
  lastMonth,
  lastQuarter,
  lastYear,
];

export const searchCashFlows = (cashFlows: CashFlowLine[], searchTerm: string): CashFlowLine[] => {
  if (searchTerm.trim().length < 2) {
    return cashFlows;
  }

  return cashFlows.filter(
    (cf) => cf.name.toLowerCase().includes(searchTerm) || cf.fundName.toLowerCase().includes(searchTerm)
  );
};
